const replaceAttributes = (html: string): string => {

    // replace all attributes except href, because we dont want to have any classes or targets
    return html.replace(/\s+(?!(href|target))\w+=\\?\"[a-z0-9?&+-_\/.:# ]+\\?\"/ig, '');

};

const replaceTags = (html: string): string => {

    const regexFilterTags = new RegExp(/([^<>])*<\/?(div|ul|li|p|a|b|i|u|br|span)(\s*?(href|target)=\\?\"[a-z0-9?&+-_\/.:# ]+\\?\"\s*?)*?\/?>([^<>])*/, 'gi');

    const regexMatch = html.match(regexFilterTags);

    if (null === regexMatch) {
        return '';
    }

    return regexMatch.join('');
};

/**
 * replace unintended markup from string
 * @param markup
 */
const cleanUpMarkup = (html: string): string => {
    // put everything in a div to protect text-only
    html = `<div>${html}</div>`;

    html = replaceAttributes(html);

    html = replaceTags(html);

    if ('<div></div>' === html) {
        return '';
    }

    // remove noopener no referrer - do add it twice
    html = html.replace(/rel=['"]\s*noopener\s*noreferrer\s*['"]/gi, '');
    html = html.replace(/rel=['"]\s*noreferrer\s*noopener\s*['"]/gi, '');
    // replace target with target blank and noopener noreferrer
    html = html.replace(/target=\s*\\?\s*[\"'][a-z0-9-_\/.:# ]+\s*\\?\s*[\"']/gi, 'target="_blank" rel="noopener noreferrer"');

    return html;
};

export default cleanUpMarkup;
